// extracted by mini-css-extract-plugin
export default {"channel_item":"ChannelBlock_channel_item__Rksuw","active":"ChannelBlock_active__V-XaT"};